export const currentDateString = () => new Date().toISOString();